import { useQuery } from 'react-query'
import type { GetCalendarIntegrationsSummariesResponse } from '../../types'
import { logFactory } from '../../util'
import { useAppointmentsService } from '../services'

const hookName = 'useCalendarIntegrationsSummaries'
const log = logFactory(hookName)

export interface UseCalendarIntegrationsSummariesOptions {
  enabled?: boolean
}

/**
 * Fetches calendar integrations summaries for the given entity ids (e.g. shop ids).
 * Uses GET /api/v1/calendar-integrations-summaries?id=...
 * Only runs when ids has length and service is ready.
 */
const useCalendarIntegrationsSummaries = (ids: string[], options: UseCalendarIntegrationsSummariesOptions = {}) => {
  const { getCalendarIntegrationsSummaries, isReady } = useAppointmentsService()
  const { enabled: optionsEnabled = true } = options

  const fetchSummaries = async (): Promise<GetCalendarIntegrationsSummariesResponse> => {
    log(`Fetching calendar integrations summaries...`, { id: ids })
    const data = await getCalendarIntegrationsSummaries({ id: ids })
    log(`Found calendar integrations summaries`, data)
    return data
  }

  const isQueryEnabled = Boolean(isReady && ids?.length > 0 && optionsEnabled)

  return useQuery([hookName, ids.join(',')], fetchSummaries, {
    enabled: isQueryEnabled,
  })
}

export { useCalendarIntegrationsSummaries }
